
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lending-service-partners",
      function () {
        return require("private-next-pages/lending-service-partners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lending-service-partners"])
      });
    }
  